{
	"label": "Traceability of carbon reductions",
	"title": "Traceability of carbon reductions",
	"paragraph": "Carbon reductions can be securely stored on a blockchain, ensuring transparency and traceability. By leveraging blockchain technology, each carbon-reduction transaction can be recorded and verified in a decentralised and immutable manner. This allows for a reliable and auditable system where emissions reductions can be accurately tracked and accounted for. Meaning a transaction for the same 1 carbon credit, can't be done multiple times.",
	"close": "Close"
}
